module.exports = __webpack_public_path__ + "img/cnu_thumbnail.916aecf4.jpg";